// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AcceptableUseRouteImport } from './routes/acceptable-use'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as CookiesRouteImport } from './routes/cookies'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as ImpressumRouteImport } from './routes/impressum'
import { Route as LoginRouteImport } from './routes/login'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as VerifyPendingRouteImport } from './routes/verify-pending'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/_admin'
import { Route as AuthenticatedBillingRouteImport } from './routes/_authenticated/billing'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedGalleryRouteImport } from './routes/_authenticated/gallery'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings'
import { Route as PromptsIndexRouteImport } from './routes/prompts/index'
import { Route as PromptsSlugRouteImport } from './routes/prompts/$slug'
import { Route as AuthenticatedAdminEmailsRouteImport } from './routes/_authenticated/_admin/emails'
import { Route as AuthenticatedGenerationIdRouteImport } from './routes/_authenticated/generation.$id'
import { Route as PromptsCategoryCategoryRouteImport } from './routes/prompts/category/$category'
import { Route as PromptsTagTagRouteImport } from './routes/prompts/tag/$tag'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRoute = AuthenticatedRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AcceptableUseRoute = AcceptableUseRouteImport.update({
            id: '/acceptable-use',path: '/acceptable-use',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const CookiesRoute = CookiesRouteImport.update({
            id: '/cookies',path: '/cookies',getParentRoute: () => rootRouteImport
          })
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => rootRouteImport
          })
const ImpressumRoute = ImpressumRouteImport.update({
            id: '/impressum',path: '/impressum',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const SignupRoute = SignupRouteImport.update({
            id: '/signup',path: '/signup',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const VerifyPendingRoute = VerifyPendingRouteImport.update({
            id: '/verify-pending',path: '/verify-pending',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
            id: '/_admin',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedBillingRoute = AuthenticatedBillingRouteImport.update({
            id: '/billing',path: '/billing',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedGalleryRoute = AuthenticatedGalleryRouteImport.update({
            id: '/gallery',path: '/gallery',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AuthenticatedRoute
          })
const PromptsIndexRoute = PromptsIndexRouteImport.update({
            id: '/prompts/',path: '/prompts/',getParentRoute: () => rootRouteImport
          })
const PromptsSlugRoute = PromptsSlugRouteImport.update({
            id: '/prompts/$slug',path: '/prompts/$slug',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAdminEmailsRoute = AuthenticatedAdminEmailsRouteImport.update({
            id: '/emails',path: '/emails',getParentRoute: () => AuthenticatedAdminRoute
          })
const AuthenticatedGenerationIdRoute = AuthenticatedGenerationIdRouteImport.update({
            id: '/generation/$id',path: '/generation/$id',getParentRoute: () => AuthenticatedRoute
          })
const PromptsCategoryCategoryRoute = PromptsCategoryCategoryRouteImport.update({
            id: '/prompts/category/$category',path: '/prompts/category/$category',getParentRoute: () => rootRouteImport
          })
const PromptsTagTagRoute = PromptsTagTagRouteImport.update({
            id: '/prompts/tag/$tag',path: '/prompts/tag/$tag',getParentRoute: () => rootRouteImport
          })





const AuthenticatedAdminRouteChildren = {
  AuthenticatedAdminEmailsRoute: AuthenticatedAdminEmailsRoute
}

const AuthenticatedAdminRouteWithChildren = AuthenticatedAdminRoute._addFileChildren(AuthenticatedAdminRouteChildren)



const AuthenticatedRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRouteWithChildren,AuthenticatedBillingRoute: AuthenticatedBillingRoute,AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,AuthenticatedGalleryRoute: AuthenticatedGalleryRoute,AuthenticatedSettingsRoute: AuthenticatedSettingsRoute,AuthenticatedGenerationIdRoute: AuthenticatedGenerationIdRoute
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(AuthenticatedRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRoute: AuthenticatedRouteWithChildren,AboutRoute: AboutRoute,AcceptableUseRoute: AcceptableUseRoute,ContactRoute: ContactRoute,CookiesRoute: CookiesRoute,ForgotPasswordRoute: ForgotPasswordRoute,ImpressumRoute: ImpressumRoute,LoginRoute: LoginRoute,PrivacyRoute: PrivacyRoute,ResetPasswordRoute: ResetPasswordRoute,SignupRoute: SignupRoute,TermsRoute: TermsRoute,VerifyPendingRoute: VerifyPendingRoute,PromptsSlugRoute: PromptsSlugRoute,PromptsIndexRoute: PromptsIndexRoute,PromptsCategoryCategoryRoute: PromptsCategoryCategoryRoute,PromptsTagTagRoute: PromptsTagTagRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)